import React from 'react'
import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { ecAccountService } from '@services/operator/ecAccountService'
import EcAccountList from '@components/shared/ec_accounts/EcAccountList'

export default function OperatorEcAccountsList() {
  const { merchants, merchant } = useOperatorData()
  const isStandard = useIsStandard()

  return (
    <EcAccountList
      service={ecAccountService}
      role="operator"
      merchants={merchants}
      currentMerchant={merchant}
      hideMerchantUI={isStandard}
    />
  )
}
